import { CSSProperties } from "react";

export const BracketHeading = ({ children, style }: { children: React.ReactNode; style?: CSSProperties }) => (
  <div className="absolute top-0 flex w-full justify-center bg-background-95 p-1" style={{ ...style }}>
    <p className="font-style-label-l4">{children}</p>
  </div>
);
